// import { createStore, withProps } from "@ngneat/elf";
// import { withStorage } from '@ngneat/elf-storage';

// export const hasFogPStore = createStore(
//   { name: 'featureFlag' },
//     withProps<{ hasForms: boolean | undefined }>({
//     hasForms: undefined
//   }),
//   withStorage('local', { key: 'featureFlag' })
// );

// import { createStore, withProps } from '@ngneat/elf';
// import { persistState } from '@ngneat/elf-persist-state';

// export interface FeatureFlagState {
//   flag: boolean;
// }

// export const featureFlagStore = createStore(
//   { name: 'featureFlag' },
//   withProps<FeatureFlagState>({ flag: false })
// );

// persistState(featureFlagStore, {
//   key: 'featureFlag',
//   storage: localStorage
// });

import { Injectable } from '@angular/core';
import { createStore, withProps, select } from '@ngneat/elf';
import { persistState, sessionStorageStrategy  } from '@ngneat/elf-persist-state';
import { Observable } from 'rxjs';

export interface HasFogPStore {
  flag: boolean | undefined;
}

@Injectable({ providedIn: 'root' })
export class HasFogPService {
  private featureFlagStore = createStore(
    { name: 'featureFlag' },
    withProps<HasFogPStore>({ flag: undefined })
  );

  constructor() {
    persistState(this.featureFlagStore, {
      key: 'featureFlag',
      storage: sessionStorageStrategy
    });
  }

  hasForms$: Observable<boolean | undefined> = this.featureFlagStore.pipe(
    select(state => state.flag)
  );

  setHasForms(value: boolean) {
    this.featureFlagStore.update(state => ({ ...state, flag: value }));
  }

  getHasForms(): boolean | undefined {
    return this.featureFlagStore.getValue().flag;
  }
}
